import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, switchMap, exhaustMap, debounceTime } from 'rxjs/operators';
import { of } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AdminPartialState } from './admin-user.reducer';
import * as AdminUserActions from './admin-user.actions';
import { APIService } from '../../services/api/api.service';
import { Store } from '@ngrx/store';

@Injectable()
export class AdminUserEffects {
  private cachedQuery: string;
  /* ------------------------------ getAdminUsers ----------------------------- */
  constructor(
    private actions$: Actions,
    private apiService: APIService,
    private notification: NzNotificationService,
    private store: Store<AdminPartialState>
  ) {}
  getAdminUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserActions.getAdminUsers),
      debounceTime(500),
      switchMap(({ query, ignoreCache }) => {
        if (!ignoreCache && JSON.stringify(query || {}) === this.cachedQuery) {
          return of(AdminUserActions.nullAction());
        } else {
          this.cachedQuery = JSON.stringify(query || {});
          return this.apiService.getAdminUsers(query).pipe(
            map(adminUsers =>
              AdminUserActions.getAdminUsersSuccess({ adminUsers, query: JSON.stringify(query) })
            ),
            catchError(error => {
              console.error('Error', error);
              this.notification.error('Error', 'There was an error loading admin users.');
              return of(AdminUserActions.getAdminUsersFailure({ error }));
            })
          );
        }
      })
    )
  );

  /* ----------------------------- createAdminUser ---------------------------- */

  createAdminUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserActions.createAdminUser),
      switchMap(action => of(AdminUserActions.createAdminUserFailure({ error: 'Not implemented' as any })))
    )
  );

  /* ----------------------------- updateAdminUser ---------------------------- */

  updateAdminUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserActions.updateAdminUser),
      switchMap(action => of(AdminUserActions.updateAdminUserFailure({ error: 'Not implemented' as any, adminUserId: action.adminUser._id })))
    )
  );

  /* ---------------------------- Delete admin user --------------------------- */

  deleteAdminUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserActions.deleteAdminUser),
      switchMap(action => of(AdminUserActions.deleteAdminUserFailure({ error: 'Not implemented' as any })))
    )
  );

  /* ------------------------ Reset admin user password ----------------------- */

  resetAdminUserPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserActions.resetAdminUserPassword),
      switchMap(action => of(AdminUserActions.resetAdminUserPasswordFailure({ error: 'Not implemented' as any })))
    )
  );
}
